import Vue from 'vue';

Vue.component('configurator-offer-step', {
    props: {},

    data() {
        return {
            data: null,
        };
    },

    async mounted() {
        EventBus.$on('configurator-offer-step', (data) => {
            this.data = data;
        });
    },

    destroyed() {},

    watch: {},

    methods: {
        parseTransformedImage(image) {
            return JSON.parse(image);
        },

        closeSummaryScreen() {
            this.data = null;
            EventBus.$emit('close-summary-screen');
        },

        getCalculatedPriceWithCopy(currency, data) {
            const price = data;
            if (currency.includes('{price}')) {
                return currency.replace('{price}', price);
            }
            return `${currency} ${price}`;
        },
    },
});
